import { store } from "../../app/mainReducer";

export const getDecimalPlacesOfSystem = () => store.getState().sistema?.parametros?.decimal_places ?? 2;